import classNames from 'classnames';
import { useMemo } from 'react';

import AspectRatio from 'components/AspectRatio';
import { AspectRatioDimensions } from 'components/AspectRatio/enums';
import BannerCenteredContent from 'components/Banner/BannerCenteredContent';

import type { BannerWithImageProps } from './types';

import useStyles from './styles';

function BannerWithImageFallback({ actionFromRight }: BannerWithImageProps) {
  const styles = useStyles();

  const classes = useMemo(
    () => ({
      original: !actionFromRight,
      recent: actionFromRight,
    }),
    [actionFromRight],
  );

  // CLASSNAMES
  const bannerClassNames = classNames(styles.root, 'original', 'bg-accented', {
    'image-uploader': !actionFromRight,
  });
  const wrapperClassNames = classNames(styles.wrapper, classes);
  const gridClassNames = classNames(styles.grid, classes);
  const contentClassNames = classNames(styles.column, styles.contentFallback, 'content', classes);
  const mediaClassNames = classNames(styles.column, 'image', classes);
  const actionClassNames = classNames(styles.column, styles.actionFallback, 'action', classes);

  return (
    <div className={bannerClassNames} data-testid="BannerWithImageFallback-test">
      <BannerCenteredContent
        isPrimary={!actionFromRight}
        templatesDimensions={actionFromRight}
        className={wrapperClassNames}
      >
        <div className={gridClassNames}>
          {/* CONTENT */}
          <div className={contentClassNames}>
            <div className="title">
              <i className="skeleton" />
            </div>
            <div className="desc">
              <i className="skeleton" />
            </div>
          </div>
          {/* MEDIA */}
          <div className={mediaClassNames}>
            <AspectRatio
              dimension={{
                xl: actionFromRight ? AspectRatioDimensions.Full : AspectRatioDimensions.Standard,
              }}
            >
              <i className="skeleton" />
            </AspectRatio>
          </div>
          {/* ACTION */}
          <div className={actionClassNames}>
            <i className="skeleton" />
          </div>
        </div>
      </BannerCenteredContent>
    </div>
  );
}

export default BannerWithImageFallback;
